import React from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Title from '../Common/Title';
import {CustomPieChart} from './Charts';
import Link from '@mui/material/Link';
// import styles from '../../styles.css';

function PieChartTile({header, slice, data, height}) {
  const boxShadowStyle = {
    boxShadow:
      '0 22px 25px 0 rgb(228 228 234 / 22%), 0 9px 23px 0 rgb(228 228 234 / 50%)',
    '&:hover': {
      boxShadow:
        '0 22px 32px 0 rgb(228 228 234 / 56%), 0 9px 28px 0 rgb(228 228 234 / 64%)',
    },
  };

  return (
    <Paper
      sx={[
        {
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          padding: '48px 64px',
          borderRadius: '12px',
        },
        boxShadowStyle,
      ]}
      elevation={24}>
      <Title>{header}</Title>
      <CustomPieChart data={data} slice={slice} height={height} />
    </Paper>
  );
}

export default PieChartTile;
